import { createFileRoute } from "@tanstack/react-router";
import { AdminSolutionMenuPanel } from "@/components/admin/AdminSolutionMenuPanel";

export const Route = createFileRoute("/admin/solution-menu")({
  component: AdminSolutionMenuPanel,
  head: () => ({ meta: [{ title: "Menú de Soluciones — Admin" }] }),
});
